import { dayjs } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";
import { ReferralSource } from "@/referral-sources/referral-source";

export const REFERRAL_SOURCE_STATUSES = {
  notStarted: "Not started",
  active: "Active",
  ended: "Ended",
} as const;

export const calcReferralSourceStatus = (
  referralSource: ReferralSource,
): (typeof REFERRAL_SOURCE_STATUSES)[keyof typeof REFERRAL_SOURCE_STATUSES] => {
  const startDate = dayjs(referralSource.start_date);
  const endDateStr = referralSource.end_date;
  const endDate = endDateStr && dayjs(endDateStr);
  const today = dayjs().startOf("day");

  if (startDate > today) {
    return REFERRAL_SOURCE_STATUSES.notStarted;
  } else if (endDate && endDate < today) {
    return REFERRAL_SOURCE_STATUSES.ended;
  } else {
    return REFERRAL_SOURCE_STATUSES.active;
  }
};

export const ReferralSourceStatusBadge = ({
  status,
  className = "",
}: {
  status: (typeof REFERRAL_SOURCE_STATUSES)[keyof typeof REFERRAL_SOURCE_STATUSES];
  className?: string;
}) => (
  <div
    className={cn(
      "inline-block text-nowrap rounded-lg px-2 py-1 font-poppins text-[13px] tracking-[0.25px]",
      {
        "bg-blue-10": status === REFERRAL_SOURCE_STATUSES.active,
        "bg-[#D9DBE9]": status !== REFERRAL_SOURCE_STATUSES.active,
      },
      className,
    )}
  >
    {status}
  </div>
);
